// Copyright (c) 2019 Deere & Company

import './app-logo.scss';
import React from 'react';

const AppLogo = () => <span className="app-logo" />;

export default AppLogo;
